import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Form, Button } from 'react-bootstrap';

// "2026-10-18 12:30:00" -> "2026. 10. 18. 12:30"
function datumSzoveg(s) {
    if (!s) {
        return '–';
    }
    const m = /^(\d{4})-(\d\d)-(\d\d) (\d\d):(\d\d)/.exec(s);
    return m ? m[1] + '. ' + m[2] + '. ' + m[3] + '. ' + m[4] + ':' + m[5] : s;
}

// 1234000 -> "1 234 000 Ft"
function forint(osszeg) {
    return Number(osszeg).toLocaleString('hu-HU') + ' Ft';
}

function oldalszamok(oldal, oldalak) {
    const lista = [];
    for (let i = Math.max(1, oldal - 2); i <= Math.min(oldalak, oldal + 2); i++) {
        lista.push(i);
    }
    return lista;
}

const SZURO_ERTEKEK = [
    { ertek: 'mind', felirat: 'Mind' },
    { ertek: 'ingyenes', felirat: 'Ingyenes' },
    { ertek: 'fizetos', felirat: 'Fizetős' },
];

// Egy listasor és a fejlécsor magassága (px); a CSS-ben ugyanennyi. Keskeny képernyőn a sor három soros, nincs fejléc.
const SOR_MAGASSAG = 41;
const SOR_MAGASSAG_KESKENY = 66;
const FEJLEC_MAGASSAG = 36;
const ALSO_MARGO = 24;

// Hány sor fér el a képernyőn a lista helyétől lefelé: a lista soha nem görgethet, ezért mindig annyi sort kérünk,
// amennyi látszik. (A rendezvény-választó, a kereső, a szűrő és a lapozó a lista fölött van.)
function szamolMeret(listaElem) {
    if (!listaElem) {
        return 20;
    }
    const keskeny = window.innerWidth < 768;
    const sorMagassag = keskeny ? SOR_MAGASSAG_KESKENY : SOR_MAGASSAG;
    const fejlec = keskeny ? 0 : FEJLEC_MAGASSAG;
    const felso = listaElem.getBoundingClientRect().top + window.scrollY;
    const hely = window.innerHeight - felso - ALSO_MARGO - fejlec;
    return Math.max(3, Math.min(100, Math.floor(hely / sorMagassag)));
}

// A megrendelések listája (minden admin): rendezvény-választó, keresés gépelés közben, ár szerinti szűrés
// (mind / ingyenes / fizetős), a szűrt megrendelések száma és a lapozó a lista fölött; a lista a képernyőbe fér.
export default function MegrendelesekOldal({ callAPI }) {
    const [rendezvenyek, setRendezvenyek] = useState([]);
    const [rendezvenyID, setRendezvenyID] = useState('');   // '' = minden rendezvény
    const [kereso, setKereso] = useState('');                // a mezőben lévő szöveg
    const [q, setQ] = useState('');                          // a szerverre küldött keresés (késleltetve)
    const [szuro, setSzuro] = useState('mind');
    const [oldal, setOldal] = useState(1);
    const [meret, setMeret] = useState(undefined);           // hány sor fér el a képernyőn
    const [adat, setAdat] = useState(undefined);             // {megrendelesek, osszes, oldal, oldalak, meret}
    const listaHely = useRef(null);

    useEffect(() => {
        callAPI('General.listMegrendelesRendezvenyek', {}, function (resp) {
            setRendezvenyek(resp.data.rendezvenyek);
        });
    }, []);

    // Az oldalméret a képernyő méretéből adódik; átméretezéskor újraszámoljuk.
    useLayoutEffect(() => {
        setMeret(szamolMeret(listaHely.current));
        let idozito;
        function onResize() {
            clearTimeout(idozito);
            idozito = setTimeout(function () { setMeret(szamolMeret(listaHely.current)); }, 250);
        }
        window.addEventListener('resize', onResize);
        return () => { clearTimeout(idozito); window.removeEventListener('resize', onResize); };
    }, []);

    // Az adatok megérkezése után újramérünk: a lapozó és a feliratok kitöltődése eltolhatta a lista helyét.
    useEffect(() => {
        if (adat !== undefined) {
            const uj = szamolMeret(listaHely.current);
            if (uj !== meret) {
                setMeret(uj);
            }
        }
    }, [adat]);

    // Keresés gépelés közben: rövid késleltetéssel indul, hogy ne minden betű külön kérés legyen.
    useEffect(() => {
        const t = kereso.trim();
        if (t === q) {
            return;
        }
        const idozito = setTimeout(function () { setQ(t); setOldal(1); }, 300);
        return () => clearTimeout(idozito);
    }, [kereso]);

    useEffect(() => {
        if (meret === undefined) {
            return;
        }
        let elavult = false;
        const adatok = { q: q, oldal: oldal, meret: meret, szuro: szuro };
        if (rendezvenyID !== '') {
            adatok.rendezvenyID = Number(rendezvenyID);
        }
        callAPI('General.listMegrendelesek', adatok, function (resp) {
            if (!elavult) {
                setAdat(resp.data);
                if (resp.data.oldal !== oldal) {
                    setOldal(resp.data.oldal);
                }
            }
        });
        return () => { elavult = true; };
    }, [q, oldal, szuro, rendezvenyID, meret]);

    function onChange_rendezveny(e) {
        setRendezvenyID(e.target.value);
        setOldal(1);
    }

    function onKeyDown_kereso(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            setQ(kereso.trim());
            setOldal(1);
        }
    }

    function onClick_szuro(ertek) {
        setSzuro(ertek);
        setOldal(1);
    }

    const oldalak = adat ? adat.oldalak : 1;
    const aktualisOldal = adat ? adat.oldal : 1;

    return (
        <div className="megrendelesekOldal felhasznalokOldal">
            {/* legfelül: a rendezvény-választó (szűrő); az első elem a "Minden rendezvény" */}
            <div className="rendezvenyValaszto">
                <Form.Select value={rendezvenyID} onChange={onChange_rendezveny} aria-label="Rendezvény">
                    <option value="">Minden rendezvény</option>
                    {rendezvenyek.map(function (r) {
                        return <option key={r.Id} value={r.Id}>{r.Cim}{r.Kezdes ? ' (' + r.Kezdes + ')' : ''} – {r.Megrendelesek} megrendelés</option>;
                    })}
                </Form.Select>
            </div>

            <div className="eszkozSav">
                <div className="keresoBlokk">
                    <Form.Control
                        className="keresoMezo"
                        type="search"
                        placeholder="Keresés a megrendelő nevére vagy e-mail-címére"
                        maxLength={100}
                        value={kereso}
                        onChange={function (e) { setKereso(e.target.value); }}
                        onKeyDown={onKeyDown_kereso} />
                </div>
                <div className="szuroSav" role="group" aria-label="Szűrés ár szerint">
                    {SZURO_ERTEKEK.map(function (s, i) {
                        return (
                            <button
                                key={s.ertek}
                                type="button"
                                className={'szuroGomb' + (szuro === s.ertek ? ' aktiv' : '') + (i > 0 && i < SZURO_ERTEKEK.length - 1 ? ' kozepso' : '')}
                                onClick={function () { onClick_szuro(s.ertek); }}>
                                {s.felirat}
                            </button>
                        );
                    })}
                </div>
            </div>

            {/* A szűrt megrendelések száma és a lapozó a lista fölött van; mindig megjelennek, hogy a lista helye ne ugorjon. */}
            <div className="lapozoSav">
                <div className="talalatSzam">
                    {adat !== undefined ?
                        <>
                            <span>{aktualisOldal}. oldal / {oldalak}</span>
                            <span>Megrendelések száma: <b>{adat.osszes}</b></span>
                            <span>Jegyek száma: <b>{adat.osszJegy}</b></span>
                            <span title={adat.kifizetettAr !== adat.osszAr ? 'Ebből kifizetve: ' + forint(adat.kifizetettAr) : undefined}>Jegyek ára: <b>{forint(adat.osszAr)}</b></span>
                        </>
                        : ' '
                    }
                </div>
                <div className="lapozo">
                    <Button variant="outline-secondary" size="sm" disabled={aktualisOldal <= 1} onClick={function () { setOldal(1); }}>«</Button>
                    <Button variant="outline-secondary" size="sm" disabled={aktualisOldal <= 1} onClick={function () { setOldal(aktualisOldal - 1); }}>‹</Button>
                    {oldalszamok(aktualisOldal, oldalak).map(function (i) {
                        return (
                            <Button key={i} size="sm" variant={i === aktualisOldal ? 'primary' : 'outline-secondary'} onClick={function () { setOldal(i); }}>{i}</Button>
                        );
                    })}
                    <Button variant="outline-secondary" size="sm" disabled={aktualisOldal >= oldalak} onClick={function () { setOldal(aktualisOldal + 1); }}>›</Button>
                    <Button variant="outline-secondary" size="sm" disabled={aktualisOldal >= oldalak} onClick={function () { setOldal(oldalak); }}>»</Button>
                </div>
            </div>

            <div ref={listaHely}>
                {adat !== undefined && adat.megrendelesek.length === 0 ?
                    <div className="adminUres">Nincs találat.</div>
                    : undefined
                }
                {adat !== undefined && adat.megrendelesek.length > 0 ?
                    <div className="megrendelesLista">
                        <div className="megrendelesFejlec">
                            <span className="azon">ID</span>
                            <span className="datum">Megrendelés</span>
                            <span className="cim">Rendezvény</span>
                            <span className="kezdes">Kezdés</span>
                            <span className="megrendelo">Megrendelő</span>
                            <span className="jegy">Jegy</span>
                            <span className="ar">Összeg</span>
                        </div>
                        {adat.megrendelesek.map(function (m) {
                            return (
                                <div key={m.Id} className="megrendelesSor">
                                    <span className="azon">#{m.Id}</span>
                                    <span className="datum">{datumSzoveg(m.Datum)}</span>
                                    <span className="cim" title={m.RendezvenyCim}>{m.RendezvenyCim}</span>
                                    <span className="kezdes">{m.Kezdes}</span>
                                    <span className="megrendelo" title={m.Email}>
                                        <b>{m.Nev !== '' ? m.Nev : <i>(nincs név)</i>}</b> <em>{m.Email}</em>
                                    </span>
                                    <span className="jegy">{m.Jegyek} db</span>
                                    <span className="ar">
                                        {m.OsszAr > 0 ? forint(m.OsszAr) : <span className="ingyenes">ingyenes</span>}
                                        {m.OsszAr > 0 && !m.Fizetve ? <span className="nincsFizetve" title="A fizetés még nem történt meg">nincs kifizetve</span> : undefined}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                    : undefined
                }
            </div>
        </div>
    );
}
